import React, { Fragment, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import Type from "../../Redux/Type"

import '../../Styles/tabmap.css'
import ContentPopupPanel from "./ContentPopupPanel"
const PopupContentBar = () => {
    const { routeContent, isShowForPopup } = useSelector(state => state.popupPanel)
    const { loadingSearch } = useSelector(state => state.searchState);
    const { isLoading } = useSelector(state => state.quyHoach);

    const dispatch = useDispatch()
    useEffect(() => {
        try {
            window.onclick = e => {
                if (document.getElementById('custom-top-bar') !== null) {
                    if (!document.getElementById('custom-top-bar').contains(e.target) && !isLoading && !loadingSearch) {
                        dispatch({ type: Type.SHOW_KEY_ACTIVE, evt: "" });
                        dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'isShowForPopup', value: false });
                        dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'routeContent', value: null });
                    }
                }

            }
        } catch (error) {

        }

    })

    return (
        <Fragment>
            {isShowForPopup ? <div id="popup-custom">
                <span style={{zIndex: 100}} title="Đóng" onClick={() => {
                    if (!isLoading && !loadingSearch) {
                        dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'isShowForPopup', value: false });
                        dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'routeContent', value: null });
                        dispatch({ type: Type.SHOW_KEY_ACTIVE, evt: "" });
                    }
                }} className="icon-close">X</span>
                <ContentPopupPanel
                    route={routeContent}
                />
            </div> : null}
        </Fragment>
    )
}
export default PopupContentBar;
